export default __webpack_public_path__ + "static/media/model_home_mobile.3a88ddc0.png";